import { createContext, useState } from "react";
import { useFirestore } from "../hooks/useFirestore";

export const AuthContext = createContext({})

export function AuthProvider({children}) {
  const [ user, setUser] = useState(null)
  
  const {signin} = useFirestore()

  const logar = async (email, pass) => {
    await signin(email, pass)
      .then(res => {
        if(res.accessToken){
          setUser(res)
        }else{
          throw new Error('Email ou senha incorretos.')
        }
      })
  }

  

  const deslogar = () => setUser(null)

  return(
    <AuthContext.Provider value={{logado: Boolean(user), logar, user, deslogar}}>
      {children}
    </AuthContext.Provider>
  )
};